import { useCallback, useState } from 'react';

import { StorageKey } from '@/constants';

export const useDismissibleBanner = (key: StorageKey) => {
  const [isVisible, setIsVisible] = useState(() => localStorage.getItem(key) !== 'true');

  const dismiss = useCallback(() => {
    localStorage.setItem(key, 'true');
    setIsVisible(false);
  }, [key]);

  return { isVisible, dismiss };
};
